import { NgModule } from '@angular/core';
import { PermissionsDirective } from './directives/permissions.directive';
import { PermissionsService } from './services/permissions.service';
import { CoreCompanyApiService } from './services/core-company-api.service';
// import { CoreUserApiService } from './services/core-user-api.service';
import { PermissionsGuard } from './guards/permissions.guard';

@NgModule({
  declarations: [PermissionsDirective],
  imports: [],
  providers: [CoreCompanyApiService, PermissionsGuard], // CoreUserApiService,
  exports: [PermissionsDirective]
})
export class ZonarUiPermissionsModule {}
